module.exports = __webpack_public_path__ + "static/media/go-big-go-home-mobile-nav.dc61e316.jpg";